<template>
    <el-dialog class="physical--del-qua-dialog" width="550px" :visible.sync="visible" :before-close="close" title="删除" :close-on-click-modal="false">
        <el-form class='form-item' ref="formRef" :model="form" :rules="rules" label-width="140px" size="mini">
            <el-form-item label="仓库编码" prop="qualificationTypeCode" v-show="false">
                <el-input v-model="form.qualificationTypeCode" disabled class="input-class"></el-input>
            </el-form-item>
            <el-form-item label="产权分类" prop="attachmentTypeList">
                <el-select v-model="form.attachmentTypeList" :multiple="true">
                    <el-option
                        v-for="(val, index) in attachmentTypeOptions"
                        :key=index
                        :label="val.label"
                        :value="val.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" :loading="loading" @click="save">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
import { deletePhysics,queryPwQualificationQueryCondition } from '../../../../../api/addPhysicalStorage.js';

export default {
    props: {
        attachmentTypeOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            visible: false,
            loading: false,
            form: {
                qualificationTypeCode: null,
                attachmentTypeList: []
            },
            rules: {
                attachmentTypeList: [{ required: true, message: '产权分类不能为空', trigger: ['blur', 'change'] }]
            }
        };
    },
    methods: {
        // handleSelect(val) {
        //     this.form.attachmentTypeList = val;
        // },
        open() {
            this.visible = true;
            this.form.qualificationTypeCode = this.$route.query.whCode;
        },
        close() {
            this.form = {
                qualificationTypeCode: null,
                attachmentTypeList: []
            };
            this.$refs.formRef.resetFields();
            this.visible = false;
        },
        save() {
            if(this.form.qualificationTypeCode) {
                this.hasWarehouse();
            }
            else if(!this.form.qualificationTypeCode && this.form.attachmentTypeList.length) {
                let dataList = [];
                let originalList=this.attachmentTypeOptions.map(item=>{
                    return item.value;
                });
                if(Array.isArray(originalList)) {
                    for (const item of originalList) {
                        if(!this.form.attachmentTypeList.includes(item)){
                            dataList.push(item);
                        }
                    }

                }
                this.loading = true;
                let params= {attachmentTypeList:dataList}
                queryPwQualificationQueryCondition(params).then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('资质删除成功');
                        this.close();
                        this.$emit('add-refresh',res.data);
                    }
                }).finally(() => {
                    this.loading = false; });

            }
        },
        hasWarehouse(){
              this.$refs.formRef.validate().then(res => {
                    this.loading = true;
                    deletePhysics({ ...this.form }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('资质删除成功');
                            this.close();
                            this.$emit('refresh');
                        }
                    }).finally(() => { this.loading = false; });
             
            });
        }
    }
};
</script>
<style lang="less">
.physical--del-qua-dialog {
    .el-select {
        width: 100%;
    }
}
</style>